import { render, staticRenderFns } from "./editReceivableStatement.vue?vue&type=template&id=15816c8e&scoped=true&"
import script from "./editReceivableStatement.vue?vue&type=script&lang=js&"
export * from "./editReceivableStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15816c8e",
  null
  
)

export default component.exports